import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {
  StyledTableCell,
  StyledTableRow,
} from '../../pages/Timesheets/CustomStyles/StyledTable';
import CheckIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Box, TextField, Tooltip, Typography } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { SHOW_NOTIFICATION } from '../../constants';
import { TaskFieldError, YYYY_MM_DD } from '../../pages/WFH/TaskConstants';
import { LocalizationProvider } from '@mui/x-date-pickers';
import {
  getHHMMSSFromSeconds,
  getSecondsFromHHMMSS,
} from '../../utils/TimeConversionFunctions';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import KeycloakService from '../../services/KeycloakService';
import {
  approveWfhTask,
  getAllWfhTasks,
  getExceededWFHHours,
  getWfhTaskForManager,
} from '../../services/WFHService';
import { DialogBoxComponent } from '../DialogBox/DialogBoxCard';
import FlakyOutlinedIcon from '@mui/icons-material/FlakyOutlined';
import { getUserData } from '../../services/UserService';
import { useLocation } from 'react-router-dom';

const WFHTimingsDropdown = (props) => {
  const { taskData, setTaskData, wfh, userProjects, isManagerOrAdmin, refreshPage , setRefreshPage } = props;

  console.log("props" ,props);

  const [editable, setEditable] = React.useState('');
  const [fieldError, setFieldError] = React.useState({ timeDuration: false });
  const [errorMsg, setErrorMsg] = React.useState({ timeDuration: '' });
  const [timepickerField, setTimepickerField] = React.useState(null);
  const [time, setTime] = React.useState('00:00');
  const [timeError, setTimeError] = React.useState(undefined);
  const [timeErrorMsg, setTimeErrorMsg] = React.useState('');
  const [dialogContent, setDialogContent] = useState('');
  const [openDialogBox, setopenDialogBox] = React.useState(false);
  const [currentRowTask, setCurrentRowTask] = React.useState();
  const currentUserId = () => KeycloakService.getUserDetail();
  const dispatch = useDispatch();
  const [refresh, setRefresh] = React.useState(false);
  const [approvers, setApprovers] = useState({});
  const location = useLocation();

  const fetchApprovers = async () => {
    const approversData = {};
    for (const task of taskData) {
      const approver = await getUserData(task.approverId);
      approversData[task.approverId] =
        approver.data?.firstName + ' ' + approver.data?.lastName;
    }
    setApprovers(approversData);
  };

  useEffect(() => {
    fetchApprovers();
  }, [taskData]);

  const getWfhTasks = async () => {
    if (
      isManagerOrAdmin &&
      (wfh.applicationDTO.status === 'APPROVED' ||
        wfh.applicationDTO.status === 'TASK_PENDING' ||
        wfh.applicationDTO.status === 'TASK_APPROVED')
    ) {
      const task = await getWfhTaskForManager(
        currentUserId(),
        wfh.applicationDTO.id,
      );
      setTaskData(task.data.data.content);
    } else if (
      wfh.status === 'APPROVED' ||
      wfh.status === 'TASK_PENDING' ||
      wfh.status === 'TASK_APPROVED'
    ) {
      const task = await getAllWfhTasks(wfh.id, wfh.employeeId);
      setTaskData(task.data.data);
    }
  };

  useEffect(() => {
    let newTaskData = [...taskData];
    newTaskData.forEach((element) => {
      const time = element.requestedWfhHours;
      if (!element.approvedWfhHours) {
        element.approvedWfhHours = time;
      }
      element.duration = new Date(
        Date.prototype.setHours.apply(
          new Date(),
          getHHMMSSFromSeconds(time).split(':'),
        ),
      );
    });
    setTaskData(newTaskData);
  }, [refresh]);

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const getWFHQuotaExceedStatus = async (templateTaskResponse) => {
    const exceededWFHTasksResponse = await getExceededWFHHours(
      templateTaskResponse.employeeId,
      templateTaskResponse.tenantId,
      templateTaskResponse.requestedWfhHours,
    );
    const wfhQuotaExceeded = exceededWFHTasksResponse.data;
    if (wfhQuotaExceeded.data > 0) {
      setDialogContent(
        `Are you sure, you want to approve this WFHhHrsRequest? Employee has exceeded WFH quota by ${getHHMMSSFromSeconds(
          wfhQuotaExceeded.data,
        )}.`,
      );
    } else {
      setDialogContent(
        'Are you sure, you want to approve this WFHhHrsRequest?',
      );
    }
  };

  const handleForProjectName = (id) => {
    let filteredProject;
    if (location.pathname === '/hr-WFH') {
      filteredProject = userProjects.find((obj) => obj.id === id);
    } else {
      filteredProject = userProjects.find((obj) => obj.projectId === id);
    }
    if (filteredProject == undefined) {
      return 'No project';
    }
    return filteredProject.projectName;
  };

  const handleTimeError = (timeError, timeErrorMsg, index, timingsIndex) => {};

  const hourValidation = (value, index, timingsIndex) => {
    let sec = 0;
    if (value === null) {
      sec = 0;
    } else {
      sec = Math.max(0, getSecondsFromHHMMSS(value));
    }
    const secInADay = 23 * 60 * 60 + 59 * 60;
    setFieldError((prev) => {
      return { ...prev, timeDuration: false };
    });
    setErrorMsg((prev) => {
      return {
        ...prev,
        timeDuration: '',
      };
    });
    let hours = 0;
    let minutes = 0;
    if (value === null) {
      hours = 0;
      minutes = 0;
    } else {
      const [inputHours, inputMinutes] = value.split(':');
      hours = parseInt(inputHours, 10);
      minutes = parseInt(inputMinutes, 10);
    }
    // Convert the hours and minutes to numbers

    if (sec > secInADay || sec <= 0 || minutes > 59) {
      const newErrorMessage = TaskFieldError.INVALID_DURATION;
      setTimeErrorMsg(newErrorMessage);

      if (
        index == undefined ||
        index == null ||
        timingsIndex == null ||
        timingsIndex == undefined
      ) {
        setFieldError((prev) => {
          return { ...prev, timeDuration: true };
        });
        setErrorMsg((prev) => {
          return {
            ...prev,
            timeDuration: `${TaskFieldError.INVALID_DURATION}`,
          };
        });
      } else {
        handleTimeError(true, newErrorMessage, index, timingsIndex);
      }
      return 0;
    } else {
      if (index == undefined || index == null) {
        setFieldError((prev) => {
          return { ...prev, timeDuration: false };
        });
        setErrorMsg((prev) => {
          return {
            ...prev,
            timeDuration: '',
          };
        });
      } else {
        handleTimeError(false, '', index, timingsIndex);
      }
      return sec;
    }
  };

  const getTiming = (approvedWfhHours) => {
    const newDateobj = new Date();
    newDateobj.setHours(0);
    newDateobj.setMinutes(0);
    newDateobj.setSeconds(0);
    const setTimings =
      getHHMMSSFromSeconds(approvedWfhHours) === '00:00'
        ? approvedWfhHours
        : getHHMMSSFromSeconds(approvedWfhHours);
    if (setTimings !== null) {
      const timeArr = setTimings.split(':');
      let timeObj = new Date(
        newDateobj.getTime() +
          (parseInt(timeArr[0]) * 60 + parseInt(timeArr[1])) * 60000,
      );
      console.log(typeof timeObj, 'dsd', timeObj);
      return timeObj;
    }
    return null;
  };

  const onChangeTime = (value, id) => {
    let newTaskData = [...taskData];
    newTaskData.forEach((task) => {
      if (task.id === id) {
        task.duration = value;
        task.approvedWfhHours =
          value == null
            ? moment(new Date().setHours(0, 0, 0, 0)).format('HH:mm')
            : moment(new Date(value)).format('HH:mm');
      }
    });
    setTaskData(newTaskData);
  };

  const onBlur = (event, id) => {
    const value = event.target.value;
    const validatedTime = hourValidation(value);
    let newTaskData = [...taskData];
    newTaskData.forEach((task) => {
      if (task.id === id) {
        task.duration = value;
        task.approvedWfhHours = getHHMMSSFromSeconds(validatedTime);
      }
    });
    setTaskData(newTaskData);
    setTime(getHHMMSSFromSeconds(validatedTime));
  };

  const handleCheck = async () => {
    const templateTaskResponse = {
      id: currentRowTask.id,
      status: 'APPROVED',
      tenantId: currentRowTask.tenantId,
      approvedWfhHours:
        typeof currentRowTask.approvedWfhHours == 'number'
          ? currentRowTask.approvedWfhHours
          : getSecondsFromHHMMSS(currentRowTask.approvedWfhHours),
      requestedWfhHours: currentRowTask.requestedWfhHours,
      employeeId: currentRowTask.employeeId,
      applicationId: currentRowTask.applicationId,
      dateOfWfh: currentRowTask.dateOfWfh,
      approverId: currentUserId(),
      projectId: currentRowTask.projectId,
      title: currentRowTask.title,
      description: currentRowTask.description,
      isAppraisal: currentRowTask.isAppraisal,
      isUpdatedByHr: location.pathname === '/hr-WFH' ? true : false,
    };
    if (
      templateTaskResponse.approvedWfhHours >
      templateTaskResponse.requestedWfhHours
    ) {
      dipatchNotification(
        'error',
        'Approved WFH hours must be less than requested WFH Hours',
      );
    } else {
      if (fieldError.timeDuration === true) return;
      const response = await approveWfhTask(templateTaskResponse);
      dipatchNotification(response.type, response.message);
    }
    setEditable('');
    await getWfhTasks();

    setopenDialogBox(false);

    setRefresh(!refresh);

    setRefreshPage(!refreshPage);
  };

  const handleEdit = (id) => {
    setEditable(id);
  };

  const cancelEditable = (id) => {
    setEditable('');
    let newTaskData = [...taskData];
    newTaskData.forEach((task) => {
      if (task.id === id) {
        task.approvedWfhHours = task.requestedWfhHours;
        task.duration = new Date(
          Date.prototype.setHours.apply(
            new Date(),
            getHHMMSSFromSeconds(task.requestedWfhHours).split(':'),
          ),
        );
      }
    });
    setTaskData(newTaskData);
  };

  return (
    <>
      <Table size="small">
        <TableHead>
          <TableRow>
            {/* <TableCell>Date</TableCell> */}
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              Date
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              Project
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              Title
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              For Appraisal
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              Duration
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              Description
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              Approver
            </StyledTableCell>
            <StyledTableCell style={{ backgroundColor: '#4d6cd9' }}>
              Actions
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {taskData.map((row) => (
            <StyledTableRow key={row.id}>
              <StyledTableCell>{row.dateOfWfh}</StyledTableCell>
              <StyledTableCell>
                {handleForProjectName(row.projectId)}
              </StyledTableCell>
              <StyledTableCell>
                <Tooltip title={row.title || ''} arrow>
                  <Typography
                    sx={{
                      maxWidth: '12rem',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {row.title}
                  </Typography>
                </Tooltip>
              </StyledTableCell>
              <StyledTableCell>
                {row.isAppraisal == true ? 'Yes' : 'No'}
              </StyledTableCell>
              <StyledTableCell component="th" scope="row">
                {editable !== row.id ? (
                  getHHMMSSFromSeconds(row.approvedWfhHours)
                ) : (
                  <Box sx={{ width: '80%' }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        onViewChange={() => {
                          setFieldError((prev) => {
                            return { ...prev, timeDuration: false };
                          });
                          setErrorMsg((prev) => {
                            return {
                              ...prev,
                              timeDuration: '',
                            };
                          });
                        }}
                        PopperProps={{
                          sx: {
                            '& .css-1anqmj6-MuiPopper-root-MuiPickersPopper-root':
                              {
                                zIndex: 1300,
                                display: 'flex !important',
                                position: 'absolute !important',
                              },
                          },
                        }}
                        ampm={false}
                        label="Time"
                        value={getTiming(row.approvedWfhHours)}
                        onChange={(value) => onChangeTime(value, row.id)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            onBlur={(e) => onBlur(e, row.id)}
                            error={fieldError.timeDuration}
                            helperText={errorMsg.timeDuration}
                            size="small"
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Box>
                )}
              </StyledTableCell>
              <StyledTableCell>
                <Tooltip title={row.description || ''} arrow>
                  <Typography
                    sx={{
                      maxWidth: '14rem',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {row.description}
                  </Typography>
                </Tooltip>
              </StyledTableCell>
              <StyledTableCell>
                {approvers[row.approverId] || '-'}
              </StyledTableCell>
              {row.status === 'PENDING' ? (
                <StyledTableCell>
                  {editable === row.id ? (
                    <IconButton
                      sx={{ paddingLeft: '0px' }}
                      color="error"
                      onClick={() => cancelEditable(row.id)}
                    >
                      <CloseIcon />
                    </IconButton>
                  ) : (
                    <IconButton
                      color="secondary"
                      sx={{ paddingLeft: '0px' }}
                      onClick={() => handleEdit(row.id)}
                    >
                      <EditIcon />
                    </IconButton>
                  )}

                  <IconButton
                    sx={{ paddingLeft: '0px' }}
                    color="secondary"
                    onClick={() => {
                      getWFHQuotaExceedStatus(row);
                      setCurrentRowTask(row);
                      setopenDialogBox(true);
                    }}
                    style={{ marginLeft: 'auto' }}
                  >
                    <CheckIcon />
                  </IconButton>
                </StyledTableCell>
              ) : (
                <StyledTableCell>APPROVED</StyledTableCell>
              )}
            </StyledTableRow>
          ))}

          <DialogBoxComponent
            open={openDialogBox}
            handleClose={() => setopenDialogBox(false)}
            confirmText={'Approve'}
            cancelText={'Close'}
            content={dialogContent}
            title={''}
            onConfirm={handleCheck}
            onCancel={() => setopenDialogBox(false)}
            component={<></>}
            icon={<FlakyOutlinedIcon color="primary" />}
          />
        </TableBody>
      </Table>
    </>
  );
};

export default WFHTimingsDropdown;
